export default function stackedBorderRadius(mergedOptions, theme) {
  var _mergedOptions$yAxis;
  var REVERSED_STACKS_INDEX = 0;
  var hasReversedStacks = (_mergedOptions$yAxis = mergedOptions.yAxis) === null || _mergedOptions$yAxis === void 0 ? void 0 : _mergedOptions$yAxis.reversedStacks;
  var hasCustomIndex = mergedOptions.series && !!mergedOptions.series[0].index;
  var lastIndex = mergedOptions.series.length - 1;
  var customIndex;
  if (hasCustomIndex) {
    var findLowestIndex = mergedOptions.series.reduce((prev, curr) => prev.index < curr.index ? prev : curr);
    customIndex = mergedOptions.series.indexOf(findLowestIndex);
  }
  var reversedStacksIndex = (hasCustomIndex ? customIndex : REVERSED_STACKS_INDEX) || REVERSED_STACKS_INDEX;
  var lastSeriesIndex = hasReversedStacks ? reversedStacksIndex : lastIndex;

  // @ts-expect-error borderRadiusTopLeft does not exist in type SeriesOptions
  mergedOptions.series[lastSeriesIndex].borderRadiusTopLeft = theme.borderRadius2;
  // @ts-expect-error borderRadiusTopRight does not exist in type SeriesOptions
  mergedOptions.series[lastSeriesIndex].borderRadiusTopRight = theme.borderRadius2;
}